package com.budgeyet.theme

import androidx.compose.ui.graphics.Color

// "Stability & Growth" design tokens — synced from the Stitch project's Dashboard
// design system export (Manrope + slate/teal/amber palette).
val Slate900 = Color(0xFF0F172A)
val Slate800 = Color(0xFF1E293B)
val Slate700 = Color(0xFF334155)
val Slate100 = Color(0xFFF1F5F9)
val Slate50 = Color(0xFFF8FAFC)
val SlateBorder = Color(0xFFE2E8F0)
val SlateMuted = Color(0xFF64748B)

val BrandTeal = Color(0xFF006B5F)
val BrandTealLight = Color(0xFF62FAE3)

val BrandCoral = Color(0xFFDA586C)
val BrandCoralLight = Color(0xFFFFDADC)

val BrandAmber = Color(0xFFF59E0B)
val BrandAmberLight = Color(0xFFFEF3C7)

val ErrorRed = Color(0xFFBA1A1A)
